export default "__VITE_ASSET__Xc_egfBu__"